import { render, staticRenderFns } from "./MaterialDetails.vue?vue&type=template&id=af836afa&"
import script from "./MaterialDetails.vue?vue&type=script&lang=js&"
export * from "./MaterialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports